var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { PlanCreationView } from "./view";
import { dataForm } from "./planCreationsDTO";
import { useDispatch, useSelector } from "react-redux";
import LocalStorageService from "../../../services/localStorage";
import { ModalDelete } from "../../../adminCore/insurances/resources/modalDelete";
import { deleteEntity } from "../../../store/delete/actions";
import { hasPermission } from "../../../services/getNavigationPages";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { showErrorToast } from "../../../fnx/showError";
import showToast from "../../../services/toast";
import { themeCore } from "../../../assets/themes/theme";
import { GetCatalogPaymentMode } from "../../../fnx/catalog/getCatalogPaymentMode";
import { planPost, planPut } from "../../../store/plan/actions";
import { planOne } from "../../../store/plans/actions";
import { planBenefit, planBenefitCreate, planBenefitUpdate, } from "../../../store/planBenefit/actions";
import { useNavigate, useParams } from "react-router-dom";
import { coverType } from "../../../store/coverType/actions";
import { useTranslation } from "react-i18next";
import { getCatalogPaymentModeClearData } from "../../../store/catalog/actions";
import "./style.css";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var PlanCreation = function () {
    var t = useTranslation().t;
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var idPlan = useParams().idPlan;
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    var tab = useParams().tab;
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var limit = React.useState(1000)[0];
    var _c = useState(true), trigger = _c[0], setTrigger = _c[1];
    var _d = useState(""), coverTypeId = _d[0], setCoverTypeId = _d[1];
    var _e = useState(""), planId = _e[0], setPlanId = _e[1];
    var _f = useState(""), currentId = _f[0], setCurrentId = _f[1];
    var _g = useState(""), rowId = _g[0], setRowId = _g[1];
    var _h = useState([]), dataFormBenefits = _h[0], setDataFormBenefits = _h[1];
    var _j = useState([]), coverTypes = _j[0], setCoverTypes = _j[1];
    var _k = useState({
        Age: [18, 65],
    }), dataFormPrimes = _k[0], setDataFormPrimes = _k[1];
    var _l = useState(0), currentTab = _l[0], setCurrentTab = _l[1];
    var _m = useState([]), coverageTypesPrime = _m[0], setCoverageTypesPrime = _m[1];
    var _o = useState(false), triggerCoverTypePlanPost = _o[0], setTriggerCoverTypePlanPost = _o[1];
    var _p = React.useState(false), showCancelButton = _p[0], setShowCancelButton = _p[1];
    var _q = React.useState([]), scenarios = _q[0], setScenarios = _q[1];
    var _r = useState(false), openModalConfirmDelete = _r[0], setOpenModalConfirmDelete = _r[1];
    var _s = useState(true), disableBenefits = _s[0], setDisableBenefits = _s[1];
    var _t = useState(true), disablePrimes = _t[0], setDisablePrimes = _t[1];
    var _u = useState(false), editBenefit = _u[0], setEditBenefit = _u[1];
    var _v = useState(false), editPrime = _v[0], setEditPrime = _v[1];
    var _w = React.useState([]), coverageType = _w[0], setCoverageType = _w[1];
    var _x = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _x[0], setSeeToast = _x[1];
    var _y = useState(false), showAlert = _y[0], setShowAlert = _y[1];
    var _z = React.useState(0), panelActive = _z[0], setPanelActive = _z[1];
    var autoClose = React.useState(10000)[0];
    var autoCloseActive = React.useState(false)[0];
    var _0 = React.useState(false), showBenefits = _0[0], setShowBenefits = _0[1];
    var _1 = React.useState(false), showPrimes = _1[0], setShowPrimes = _1[1];
    var _2 = React.useState(dataForm), planData = _2[0], setPlanData = _2[1];
    var _3 = React.useState(false), isEditPlan = _3[0], setIsEditPlan = _3[1];
    var _4 = React.useState([]), benefitsData = _4[0], setBenefitsData = _4[1];
    var _5 = React.useState([]), primesData = _5[0], setPrimesData = _5[1];
    var _6 = React.useState([]), paymentModeList = _6[0], setPaymentModeList = _6[1];
    var _7 = useState({
        id: "",
        coverTypeId: "",
        premiumEvalOptionId: "",
        planId: "",
    }), coverTypePlanRequest = _7[0], setCoverTypePlanRequest = _7[1];
    var _8 = useSelector(function (state) { return ({
        responseCoverType: state.CoverType.responseCoverType,
        errorCoverType: state.CoverType.errorCoverType,
        loadingCoverType: state.CoverType.loadingCoverType,
    }); }), responseCoverType = _8.responseCoverType, errorCoverType = _8.errorCoverType, loadingCoverType = _8.loadingCoverType;
    var _9 = useSelector(function (state) { return ({
        responsePlan: state.Plan.responsePlanPost,
        errorPlan: state.Plan.errorPlanPost,
        loadingPlan: state.Plan.loadingPlanPost,
    }); }), responsePlan = _9.responsePlan, errorPlan = _9.errorPlan, loadingPlan = _9.loadingPlan;
    var _10 = useSelector(function (state) {
        var _a;
        return ({
            responseOnePlan: (_a = state.Plans.responseOnePlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPlans: state.Plans.errorPlans,
            loadingPlans: state.Plans.loadingPlans,
        });
    }), responseOnePlan = _10.responseOnePlan, errorPlans = _10.errorPlans, loadingPlans = _10.loadingPlans;
    var _11 = useSelector(function (state) { return ({
        responsePlanPut: state.Plan.responsePlanPut,
        errorPlanPut: state.Plan.errorPlanPut,
        loadingPlanPut: state.Plan.loadingPlanPut,
    }); }), responsePlanPut = _11.responsePlanPut, errorPlanPut = _11.errorPlanPut, loadingPlanPut = _11.loadingPlanPut;
    var _12 = useSelector(function (state) { return ({
        responsePlanBenefit: state.PlanBenefit.responsePlanBenefit,
        errorPlanBenefit: state.PlanBenefit.errorPlanBenefit,
        loadingPlanBenefit: state.PlanBenefit.loadingPlanBenefit,
    }); }), responsePlanBenefit = _12.responsePlanBenefit, errorPlanBenefit = _12.errorPlanBenefit, loadingPlanBenefit = _12.loadingPlanBenefit;
    var _13 = useSelector(function (state) { return ({
        responsePlanBenefitCreate: state.PlanBenefit.responsePlanBenefitCreate,
        errorPlanBenefitCreate: state.PlanBenefit.errorPlanBenefitCreate,
        loadingPlanBenefitCreate: state.PlanBenefit.loadingPlanBenefitCreate,
    }); }), responsePlanBenefitCreate = _13.responsePlanBenefitCreate, errorPlanBenefitCreate = _13.errorPlanBenefitCreate, loadingPlanBenefitCreate = _13.loadingPlanBenefitCreate;
    var _14 = useSelector(function (state) { return ({
        responsePlanBenefitUpdate: state.PlanBenefit.responsePlanBenefitUpdate,
        errorPlanBenefitUpdate: state.PlanBenefit.errorPlanBenefitUpdate,
        loadingPlanBenefitUpdate: state.PlanBenefit.loadingPlanBenefitUpdate,
    }); }), responsePlanBenefitUpdate = _14.responsePlanBenefitUpdate, errorPlanBenefitUpdate = _14.errorPlanBenefitUpdate, loadingPlanBenefitUpdate = _14.loadingPlanBenefitUpdate;
    var _15 = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _15.responseDeleteEntity, loadingDeleteEntity = _15.loadingDeleteEntity, errorDeleteEntity = _15.errorDeleteEntity;
    var _16 = GetCatalogPaymentMode(trigger, enable, page, limit, clientId), responseGetCatalogPaymentMode = _16.responseGetCatalogPaymentMode, errorGetCatalogPaymentMode = _16.errorGetCatalogPaymentMode, loadingGetCatalogPaymentMode = _16.loadingGetCatalogPaymentMode;
    useEffect(function () {
        if (errorGetCatalogPaymentMode) {
            showErrorToast(errorGetCatalogPaymentMode, setSeeToast, t);
        }
    }, [errorGetCatalogPaymentMode]);
    var _17 = useSelector(function (state) { return ({
        responsePostCoverTypePlan: state.CoverTypePlan.responsePostCoverTypePlan,
        errorPostCoverTypePlan: state.CoverTypePlan.errorPostCoverTypePlan,
        loadingPostCoverTypePlan: state.CoverTypePlan.loadingPostCoverTypePlan,
    }); }), responsePostCoverTypePlan = _17.responsePostCoverTypePlan, errorPostCoverTypePlan = _17.errorPostCoverTypePlan, loadingPostCoverTypePlan = _17.loadingPostCoverTypePlan;
    var permissions = {
        create: hasPermission("admin-product-plan-create"),
        update: hasPermission("admin-product-plan-edit"),
        delete: hasPermission("admin-product-plan-delete"),
    };
    useEffect(function () {
        if (errorPostCoverTypePlan) {
            showErrorToast(errorPostCoverTypePlan, setSeeToast, t);
        }
    }, [errorPostCoverTypePlan]);
    useEffect(function () {
        if ((responseGetCatalogPaymentMode === null || responseGetCatalogPaymentMode === void 0 ? void 0 : responseGetCatalogPaymentMode.length) > 0) {
            setPaymentModeList([]);
            var paymentMode = responseGetCatalogPaymentMode.map(function (item) { return ({
                id: item.id,
                name: item.description,
                value: item.id,
            }); });
            setPaymentModeList(paymentMode);
            dispatch(getCatalogPaymentModeClearData());
        }
    }, [responseGetCatalogPaymentMode]);
    useEffect(function () {
        if (responsePlanBenefit &&
            responsePlanBenefit.data &&
            responsePlanBenefit.data.length > 0) {
            setBenefitsData([]);
            responsePlanBenefit.data.map(function (item) {
                setBenefitsData(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                    { id: item.id, description: item.description, value: item.value },
                ], false); });
            });
        }
        if (errorPlanBenefit) {
            showErrorToast(errorPlanBenefit, setSeeToast, t);
        }
    }, [responsePlanBenefit, errorPlanBenefit]);
    useEffect(function () {
        if (responsePlanBenefitCreate &&
            responsePlanBenefitCreate.data &&
            responsePlanBenefitCreate.data.id) {
            dispatch(planBenefit({ enable: enable, page: page, limit: limit, planId: planId }));
            setSeeToast({
                show: true,
                message: "Beneficio creado correctamente",
                type: typeAlert.success,
            });
        }
        if (errorPlanBenefitCreate) {
            showErrorToast(errorPlanBenefitCreate, setSeeToast, t);
        }
    }, [responsePlanBenefitCreate, errorPlanBenefitCreate]);
    useEffect(function () {
        if (responsePlanBenefitUpdate &&
            responsePlanBenefitUpdate.data &&
            responsePlanBenefitUpdate.data.id) {
            setSeeToast({
                show: true,
                message: "Beneficio actualizado correctamente",
                type: typeAlert.success,
            });
            dispatch(planBenefit({ enable: enable, page: page, limit: limit, planId: planId }));
        }
        if (errorPlanBenefitUpdate) {
            showErrorToast(errorPlanBenefitUpdate, setSeeToast, t);
        }
    }, [responsePlanBenefitUpdate, errorPlanBenefitUpdate]);
    useEffect(function () {
        if (responseDeleteEntity && responseDeleteEntity.id) {
            setSeeToast({
                show: true,
                message: "Registro eliminado correctamente",
                type: typeAlert.success,
            });
            dispatch(planBenefit({ enable: enable, page: page, limit: limit, planId: planId }));
        }
        if (errorDeleteEntity) {
            showErrorToast(errorDeleteEntity, setSeeToast, t);
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    useEffect(function () {
        if (isEditPlan == true) {
            setPanelActive(0);
            setShowCancelButton(true);
            setDisableBenefits(false);
            setDisablePrimes(false);
        }
    }, [isEditPlan]);
    useEffect(function () {
        if (responsePlan && responsePlan.data && responsePlan.data.id) {
            setPlanId(responsePlan.data.id);
            // let ct = coverTypes;
            /* coverTypes.map((item: any) => {
               let bodyRequest = {
                 planId: responsePlan.data.id,
                 coverTypeId: item.id,
                 premiumEvalOptionId: "953abee0-fa8f-4341-91c0-af822a658918",
               };
       
               dispatch(coverTypePlanPost(bodyRequest));
             }); */
            setSeeToast({
                show: true,
                message: "Plan creado correctamente",
                type: typeAlert.success,
            });
            setTimeout(function () {
                setPlanId(responsePlan.data.id);
                dispatch(planOne({ id: responsePlan.data.id }));
                setIsEditPlan(true);
            }, 3000);
        }
        if (errorPlan) {
            showErrorToast(errorPlan, setSeeToast, t);
        }
    }, [responsePlan, errorPlan]);
    useEffect(function () {
        var _a;
        if (responseOnePlan && responseOnePlan.id) {
            setPlanId(responseOnePlan.id);
            setPlanData({
                Name: responseOnePlan.name,
                Code: responseOnePlan.code,
            });
            var sc_1 = [];
            (_a = responseOnePlan.scenariosPricing) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
                var _a, _b, _c, _d;
                sc_1.push({
                    id: index,
                    minAge: item === null || item === void 0 ? void 0 : item.minAge,
                    maxAge: item === null || item === void 0 ? void 0 : item.maxAge,
                    paymentModeId: (_a = item.paymentMode) === null || _a === void 0 ? void 0 : _a.id,
                    premiumEvalTypeId: "953abee0-fa8f-4341-91c0-af822a658918",
                    price: item === null || item === void 0 ? void 0 : item.price,
                    coverTypeId: (_b = item.coverType) === null || _b === void 0 ? void 0 : _b.id,
                    paymentMode: (_c = item.paymentMode) === null || _c === void 0 ? void 0 : _c.description,
                    coverType: (_d = item.coverType) === null || _d === void 0 ? void 0 : _d.description,
                });
            });
            setScenarios(sc_1);
            setCoverageTypesPrime([]);
            //setCoverageType([]);
            var ctSelected_1 = [];
            var ctAll_1 = [];
            var ct_1 = responseOnePlan.coverTypes;
            console.log("coverageType", coverageType);
            coverageType.map(function (item) {
                ct_1.map(function (item2) {
                    if (item.id == item2.id) {
                        item.active = true;
                        ctSelected_1.push(item);
                    }
                });
                ctAll_1.push(item);
            });
            console.log("ctSelected", ctSelected_1);
            console.log("ctAll", ctAll_1);
            setCoverTypes(ctSelected_1);
            setCoverageType(ctAll_1);
        }
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
        }
    }, [responseOnePlan, errorPlans]);
    useEffect(function () {
        if (responsePlanPut && responsePlanPut.data && responsePlanPut.data.id) {
            /* coverTypes.map((item: any) => {
       
               let bodyRequest = { planId: planId, coverTypeId: item.id, premiumEvalOptionId: "953abee0-fa8f-4341-91c0-af822a658918" };
               dispatch(
                 coverTypePlanPost(bodyRequest),
               );
             }
       
             );*/
            dispatch(planOne({ id: planId }));
            setSeeToast({
                show: true,
                message: "Plan actualizado correctamente",
                type: typeAlert.success,
            });
            //localStorage.setItem("tab", currentTab.toString());
            //window.location.reload();
        }
    }, [responsePlanPut]);
    useEffect(function () {
        if (errorPlanPut) {
            showErrorToast(errorPlanPut, setSeeToast, t);
        }
    }, [errorPlanPut]);
    useEffect(function () {
        if (responseCoverType &&
            responseCoverType.data &&
            responseCoverType.data.length > 0) {
            setCoverageType([]);
            responseCoverType.data.map(function (item) {
                setCoverageType(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                    { id: item.id, name: item.description, value: item.id },
                ], false); });
            });
            dispatch(planOne({ id: idPlan }));
        }
        if (errorCoverType) {
            showErrorToast(errorCoverType, setSeeToast, t);
        }
    }, [responseCoverType, errorCoverType]);
    useEffect(function () {
        dispatch(coverType({ trigger: trigger, enable: enable, page: page, limit: limit }));
        var currentT = localStorage.getItem("tab");
        setCurrentTab(0);
        if (idPlan != undefined) {
            console.log("idPlan", idPlan);
            dispatch(planBenefit({ enable: enable, page: page, limit: limit, planId: idPlan }));
        }
    }, []);
    useEffect(function () {
        if (idPlan) {
            setPlanId(idPlan);
            //dispatch(planOne({ id: idPlan }));
            setIsEditPlan(true);
        }
    }, [idPlan, idProduct]);
    var createBenefit = function (form) {
        var data = {
            description: form.Name,
            value: form.Value,
            planId: planId,
        };
        if (editBenefit) {
            dispatch(planBenefitUpdate({ data: data }, currentId));
        }
        else {
            dispatch(planBenefitCreate({ data: data }));
        }
        setShowBenefits(false);
    };
    var createPrime = function (form) {
        var data = {
            minAge: form.Age[0],
            maxAge: form.Age[1],
            paymentModeId: form.IdType,
            premiumEvalTypeId: "953abee0-fa8f-4341-91c0-af822a658918",
            price: parseFloat(form.Prime),
            coverTypeId: form.IdCoverType,
        };
        var sc = __spreadArray([], scenarios, true);
        if (editPrime) {
            sc[form.id] = data;
        }
        else {
            sc.push(data);
        }
        setScenarios(sc);
        handleUpdateScenario(sc);
        setShowPrimes(false);
    };
    var handleUpdateScenario = function (form) {
        var sc = [];
        form.map(function (item) {
            sc.push({
                minAge: item.minAge,
                maxAge: item.maxAge,
                paymentModeId: item.paymentModeId,
                premiumEvalTypeId: item.premiumEvalTypeId,
                price: item.price,
                coverTypeId: item.coverTypeId,
            });
        });
        var data = {
            name: planData.Name,
            code: planData.Code,
            projectId: idProduct,
            premiumEvalOptionId: "953abee0-fa8f-4341-91c0-af822a658918",
            scenarios: sc,
        };
        dispatch(planPut(data, planId));
    };
    var handleSubmitPlan = function (form) {
        var ct = [];
        coverTypes.map(function (item) {
            var bodyRequest = {
                coverTypeId: item.id,
                premiumEvalOptionId: "953abee0-fa8f-4341-91c0-af822a658918",
            };
            ct.push(bodyRequest);
        });
        var data = {
            name: form.Name,
            code: form.Code,
            projectId: idProduct,
            scenarios: scenarios,
            coverTypes: ct,
        };
        if (isEditPlan) {
            dispatch(planPut(data, planId));
        }
        else {
            dispatch(planPost(data));
        }
    };
    var onClickBack = function () {
        navigate("/product-creation" + "/" + idProduct + "/" + true + "/" + true);
    };
    var addPrimes = function (data) {
        setShowPrimes(true);
        setEditPrime(false);
    };
    var addBenefits = function (data) {
        setDataFormBenefits([]);
        setEditBenefit(false);
        setShowBenefits(true);
    };
    var handleAction = function (item, row, type) {
        setCurrentTab(type == "benefits" ? 0 : 1);
        setRowId(row.idrow);
        setCurrentId(row.id);
        if (item.id == "delete") {
            setOpenModalConfirmDelete(true);
        }
        if (item.id == "edit") {
            if (type == "benefits") {
                setEditBenefit(true);
                setShowBenefits(true);
                setDataFormBenefits({
                    Name: row.description,
                    Value: row.value,
                });
            }
            if (type == "primes") {
                setShowPrimes(true);
                setEditPrime(true);
                setDataFormPrimes({
                    id: row.id,
                    Age: [row.minAge, row.maxAge],
                    IdType: row.paymentModeId,
                    Prime: row.price,
                    IdCoverType: row.coverTypeId,
                });
            }
        }
    };
    var onClickDelete = function () {
        setOpenModalConfirmDelete(false);
        if (currentTab == 0) {
            dispatch(deleteEntity({
                id: currentId,
                entity: "BenefitEntity",
                idUser: lsLogin.getUserLoginStored().userId,
            }));
        }
        if (currentTab == 1) {
            var updatedScenarios = scenarios.filter(function (scenario, index) { return index !== rowId; });
            setScenarios(updatedScenarios);
            handleUpdateScenario(updatedScenarios);
        }
    };
    var handleSetCoverTypes = function (e) {
        setCoverTypes(e);
    };
    return (_jsxs(_Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({ show: false, message: "", type: typeAlert.success });
                }), _jsx(LoadingAFY, { loading: loadingCoverType ||
                    loadingPlan ||
                    loadingPlans ||
                    loadingPlanPut ||
                    loadingPlanBenefit ||
                    loadingPlanBenefitCreate ||
                    loadingPlanBenefitUpdate ||
                    loadingDeleteEntity ||
                    loadingPostCoverTypePlan ||
                    loadingGetCatalogPaymentMode, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), _jsx(ModalDelete, { openModalConfirmDelete: openModalConfirmDelete, setOpenModalConfirmDelete: setOpenModalConfirmDelete, itemCard: [], onClickDelete: onClickDelete }), _jsx(PlanCreationView, { currentTab: currentTab, permissions: permissions, onUpdateCoverTypeSelected: function (e) { return handleSetCoverTypes(e); }, dataFormPrimes: dataFormPrimes, dataFormBenefits: dataFormBenefits, coverageType: coverageType, coverageTypesPrime: coverTypes, planData: planData, scenarios: scenarios, onClickAddBenefits: addBenefits, onClickAddPrimes: addPrimes, openModalBenefit: showBenefits, onCloseModalBenefit: function () { return setShowBenefits(false); }, openModalPrime: showPrimes, onCloseModalPrime: function () { return setShowPrimes(false); }, onSaveBenefit: createBenefit, onSavePrime: createPrime, handleSubmitPlan: handleSubmitPlan, handleClickContextMenu: handleAction, showAlert: showAlert, panelActive: currentTab, autoClose: autoClose, autoCloseActive: autoCloseActive, setShowAlert: setShowAlert, onClickBack: onClickBack, disableBenefits: disableBenefits, disablePrimes: disablePrimes, idPlan: planId, isEdit: isEditPlan.toString(), benefitsData: benefitsData, showCancelButton: showCancelButton, activateEditMode: !isEditPlan, coverageTypeList: coverageType, paymentModeList: paymentModeList, 
                // Remove the duplicate attribute 'panelActive={currentTab}'
                // panelActive={currentTab}
                setShowCancelButton: function (value) {
                    throw new Error("Function not implemented.");
                } })] }));
};
